import _get from 'lodash/get';
import * as chartsApi from '../common/api/charts';
import { formatChartTypes } from '../utils/basinCharts';

export const FETCH_SUBREGION_CHART_IMAGES = 'FETCH_SUBREGION_CHART_IMAGES';
export const FETCH_SUBREGION_CHART_IMAGES_SUCCESS = 'FETCH_SUBREGION_CHART_IMAGES_SUCCESS';
export const FETCH_SUBREGION_CHART_IMAGES_FAILURE = 'FETCH_SUBREGION_CHART_IMAGES_FAILURE';

export const FETCH_SUBREGION_CHART_MENU = 'FETCH_SUBREGION_CHART_MENU';
export const FETCH_SUBREGION_CHART_MENU_SUCCESS = 'FETCH_SUBREGION_CHART_MENU_SUCCESS';
export const FETCH_SUBREGION_CHART_MENU_FAILURE = 'FETCH_SUBREGION_CHART_MENU_FAILURE';

export const SET_ACTIVE_CHART = 'SET_ACTIVE_CHART';

export const fetchChartImages = (type, nearshoreModelName) => async (dispatch, getState) => {
  dispatch({
    type: FETCH_SUBREGION_CHART_IMAGES,
  });
  try {
    const state = getState();
    const legacyId = _get(state, 'subregion.overview.associated.legacyId', null);
    const {
      data: { images },
      associated: { timezone },
    } = await chartsApi.fetchLegacyChartImages(legacyId, type, nearshoreModelName);
    dispatch({
      type: FETCH_SUBREGION_CHART_IMAGES_SUCCESS,
      images,
      timezone,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SUBREGION_CHART_IMAGES_FAILURE,
      error,
    });
  }
};

export const fetchChartTypes = (subregionId, cookies) => async dispatch => {
  dispatch({
    type: FETCH_SUBREGION_CHART_MENU,
  });
  try {
    const {
      data: { types },
      associated: { region },
    } = await chartsApi.fetchLegacyChartTypes(subregionId, cookies);

    const formattedTypes = formatChartTypes(types);
    dispatch({
      type: FETCH_SUBREGION_CHART_MENU_SUCCESS,
      types: formattedTypes,
      region,
    });
  } catch (error) {
    dispatch({
      type: FETCH_SUBREGION_CHART_MENU_FAILURE,
      error,
    });
  }
};

// find the chart using the slug as a lookup
const getActiveChartBySlug = (slug, types) => {
  let activeChart = {};
  Object.keys(types).forEach(category => {
    types[category].forEach(chart => {
      if (chart.slug === slug) {
        activeChart = {
          ...chart,
          category,
        };
      }
    });
  });
  return activeChart;
};

export const setActiveChart = (slug, subregionId, cookies) => async (dispatch, getState) => {
  const state = getState();
  let chartTypes = _get(state, 'components.charts.types', null);

  if (!chartTypes) {
    await dispatch(fetchChartTypes(subregionId, cookies));
    chartTypes = _get(getState(), 'components.charts.types', []);
  }

  const active = getActiveChartBySlug(slug, chartTypes);

  dispatch({
    type: SET_ACTIVE_CHART,
    active,
  });
};
